module.exports = __webpack_public_path__ + "img/page-hero.cc718068.jpg";